import React from 'react';
import {getOutlet} from 'reconnect.js';

function useDetectDimension(md = 768, lg = 1200) {
  const detectDimension = React.useCallback(() => {
    if (typeof window !== 'undefined') {
      const nextDimension = {
        rwd: 'mobile',
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
      };
      if (window.innerWidth > lg) {
        nextDimension.rwd = 'desktop';
      } else if (window.innerWidth > md) {
        nextDimension.rwd = 'tablet';
      }
      getOutlet('dimension').update(nextDimension);
    }
  }, [md]);

  const onResize = React.useCallback(() => {
    detectDimension();
  }, [detectDimension]);

  React.useEffect(() => {
    try {
      detectDimension();
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', onResize);
      }
      return () => {
        if (typeof window !== undefined) {
          window.removeEventListener('resize', onResize);
        }
      };
    } catch (ex) {
      console.warn('Provider:useEffect', ex);
    }
  }, [onResize, detectDimension]);
}

export default useDetectDimension;
